import { ConnectionInitMessage, SubscribeMessage, MessageType } from 'graphql-ws'

const GRAPHQL_TRANSPORT_WS_PROTOCOL = 'graphql-transport-ws'
const WS_URL = process.env.NEXT_PUBLIC_WS_URL + '/graphql/'

export class GraphQLSubscription {
  private static connection: WebSocket
  private static connection_ready = false

  private static message_handlers: ((event) => void)[] = []

  public static connect(): WebSocket {
    if (!GraphQLSubscription.connection) {
      GraphQLSubscription.connection = new WebSocket(WS_URL, GRAPHQL_TRANSPORT_WS_PROTOCOL)

      const init: ConnectionInitMessage = {
        type: MessageType.ConnectionInit,
        payload: {
          Authorization: `JWT ${localStorage.getItem('jwt')}`,
        },
      }

      GraphQLSubscription.connection.onopen = () => {
        GraphQLSubscription.connection.send(JSON.stringify(init))
      }

      GraphQLSubscription.connection.addEventListener('message', (event) => {
        const message = JSON.parse(event.data)
        if (message.type === MessageType.ConnectionAck) {
          GraphQLSubscription.connection_ready = true
        }

        if (message.type === MessageType.Next) {
          GraphQLSubscription.message_handlers.forEach((handler) => handler(message))
        }
      })
    }

    return GraphQLSubscription.connection
  }

  public static subscribe(
    document: string,
    variables: Record<string, unknown> | null,
    eventHandler: (event) => void
  ) {
    const subscribe: SubscribeMessage = {
      id: Math.random().toString(16).slice(2),
      type: MessageType.Subscribe,
      payload: {
        query: document,
        variables: variables,
      },
    }

    if (GraphQLSubscription.connection_ready) {
      GraphQLSubscription.connection.send(JSON.stringify(subscribe))
    } else {
      GraphQLSubscription.connection.addEventListener('message', (event) => {
        const message = JSON.parse(event.data)
        if (message.type === MessageType.ConnectionAck) {
          GraphQLSubscription.connection.send(JSON.stringify(subscribe))
        }
      })
    }

    GraphQLSubscription.message_handlers.push(eventHandler)
  }
}
